var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-sole-xl-theme-provider/src/NikeThemeProvider.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import JssProvider from 'react-jss/lib/JssProvider';
import { createMuiTheme, jssPreset, MuiThemeProvider } from '@material-ui/core/styles';
import { create } from 'jss';
import { css } from 'glamor';
import defaultTheme from './theme';
import { merge } from './util';
import { defaultAttributes, defaultGlobals } from './styles';
import NikeStylesContext, { defaultStylesContext } from './context';
/**
 * CSS created through Material-UI directly has the highest specificity since its `<link>` is
 * injected as the last child of the `<head>` tag. For Glamor-JSS style library interoperability to
 * work without needing to splash `!important` directives everywhere, we need to modify the CSS
 * injection order.
 */

var styleNode = document.createElement('NOSCRIPT');
styleNode.setAttribute('id', 'jss-insertion-point');
document.head.insertBefore(styleNode, document.head.firstChild);
var defaultJssInstance = create(_objectSpread({}, jssPreset(), {
  insertionPoint: document.getElementById('jss-insertion-point')
}));

var NikeThemeProvider = function NikeThemeProvider(_ref) {
  var attributeExtension = _ref.attributeExtension,
      children = _ref.children,
      classNamesGenerator = _ref.classNamesGenerator,
      globals = _ref.globals,
      jssInstance = _ref.jssInstance,
      styleExtension = _ref.styleExtension,
      themeExtension = _ref.themeExtension;
  // Merge/apply extensions
  var appliedTheme = createMuiTheme(merge(defaultTheme, themeExtension));
  var attributes = merge(defaultAttributes, attributeExtension); // Global glamor overrides must be inserted one-by-one:

  Object.entries(globals).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        selector = _ref3[0],
        style = _ref3[1];

    css.global(selector, style);
  });
  return React.createElement(JssProvider, {
    generateClassName: classNamesGenerator,
    jss: jssInstance,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46
    },
    __self: this
  }, React.createElement(MuiThemeProvider, {
    theme: appliedTheme,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }, React.createElement(NikeStylesContext.Provider, {
    value: _objectSpread({}, defaultStylesContext, {
      attributes: attributes,
      styleExtension: styleExtension
    }),
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48
    },
    __self: this
  }, children)));
};

NikeThemeProvider.propTypes = {
  /** Extends or overrides the default attributes. */
  attributeExtension: PropTypes.objectOf(PropTypes.object),

  /** Theme provider children. */
  children: PropTypes.node,

  /** A function which returns a className generator function. */
  classNamesGenerator: PropTypes.func,

  /** Applied global styles. */
  globals: PropTypes.objectOf(PropTypes.object),

  /** A custom configured JSS instance */
  jssInstance: PropTypes.shape({}),

  /** Extends and overrides NACL styles. */
  styleExtension: PropTypes.shape({}),

  /** A custom Material-UI v1 compatible theme object that is deep-merged with the preset. */
  themeExtension: PropTypes.shape({
    /** Collection of Material-UI component styles overrides. */
    overrides: PropTypes.object,

    /** Any valid object of palette intentions. */
    palette: PropTypes.object,

    /** An object of typography overrides. */
    typography: PropTypes.object
  })
};
NikeThemeProvider.defaultProps = {
  attributeExtension: {},
  globals: defaultGlobals,
  jssInstance: defaultJssInstance,
  styleExtension: {},
  themeExtension: {}
};
NikeThemeProvider.displayName = 'NikeThemeProvider';
export default NikeThemeProvider;